import { Sun as Sun_kojaro } from './Sun.kojaro';
import { Sun as Sun_phosphor } from './Sun.phosphor';
import { Sun as Sun_zoomg } from './Sun.zoomg';
import { Sun as Sun_zoomit } from './Sun.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Sun_kojaro;

    case 'zoomg':
      return Sun_zoomg;

    case 'phosphor':
      return Sun_phosphor;

    default:
      return Sun_zoomit;
  }
};

export const Sun = IconRenderer();
